import { Component } from '@angular/core';

@Component({
    selector: 'ctfo-dialog-title',
    templateUrl: './dialog-title.component.html',
    styleUrls: ['./dialog-title.component.scss'],
    standalone: false
})
export class DialogTitleComponent {}
